/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Sativa = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Sativa 24">
      <rect
        width={22}
        height={22}
        x={1}
        y={1}
        stroke="#0E0E0E"
        strokeWidth={2}
        className="Rectangle 644"
        rx={3}
      />
      <path
        fill="#0E0E0E"
        d="M12.523 17.18c-.66 0-1.3-.125-1.92-.375a5.011 5.011 0 0 1-1.62-1.065l1.02-1.185c.35.33.75.6 1.2.81.45.2.9.3 1.35.3.56 0 .985-.115 1.275-.345.29-.23.435-.535.435-.915 0-.41-.145-.705-.435-.885a7.6 7.6 0 0 0-1.08-.555l-1.35-.585c-.32-.14-.635-.32-.945-.54-.3-.22-.55-.5-.75-.84-.19-.34-.285-.75-.285-1.23 0-.52.14-.985.42-1.395.29-.42.68-.75 1.17-.99.5-.25 1.07-.375 1.71-.375.57 0 1.12.115 1.65.345.53.22.985.52 1.365.9l-.885 1.11c-.31-.26-.64-.465-.99-.615-.34-.15-.72-.225-1.14-.225-.46 0-.835.105-1.125.315-.28.2-.42.48-.42.84 0 .25.07.46.21.63.15.16.345.3.585.42.24.11.495.22.765.33l1.335.555c.58.25 1.055.58 1.425.99.37.4.555.955.555 1.665 0 .53-.14 1.015-.42 1.455-.28.44-.685.795-1.215 1.065-.52.26-1.15.39-1.89.39Z"
        className="S"
      />
    </g>
  </svg>
);

export const SativaIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'sativa-icon'}
      icon={Sativa}
      {...props}
      size={size}
    />
  );
};
